import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../../components/AppIcon';

const color = '#348CE3';

export const AppItem = ({ onAppRemove, app: { ref_no, big_icon_url, icon_url, store, name } }) => (
  <div className="report-analysis-application">
    <AppIcon
      url={big_icon_url || icon_url}
      store={store}
      size={48}
      alt={name}
      containerClasses="img-rounded report-analysis-application-icon"
      hideHtmlTitle
      withBorder
    />

    <div className="report-analysis-application-name text-truncate">{name}</div>

    <div className="report-analysis-application-remove" onClick={() => onAppRemove(ref_no)}>
      <i className="hicon-close cursor-pointer" />
    </div>
  </div>
);

AppItem.propTypes = {
  onAppRemove: T.func.isRequired,
  app: T.shape({
    ref_no: T.oneOfType([T.string, T.number]),
    big_icon_url: T.string,
    icon_url: T.string,
    store: T.string,
    name: T.string,
  }).isRequired,
};

export const AppPlaceholder = ({ onPlaceholderClick, isActiveItem, itemNumber, customTexts }) => {
  const handlePlaceholderClick = () => {
    if (isActiveItem) onPlaceholderClick();
  };

  let placeholderText = `Select app #${itemNumber}`;
  if (customTexts.app_selection_text) {
    placeholderText = `${customTexts.app_selection_text} #${itemNumber}`;
  }

  return (
    <div
      onClick={handlePlaceholderClick}
      className={cx('report-analysis-application-empty', {
        'report-analysis-application-empty-active': isActiveItem,
      })}
    >
      <div className="report-analysis-application-empty-icon">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="47"
            height="47"
            rx="7.5"
            stroke={color}
            strokeDasharray="2 2"
          />
          <text x="50%" y="54%" dominantBaseline="middle" fill={color} textAnchor="middle">
            +
          </text>
        </svg>
      </div>
      <div className="report-analysis-application-empty-app-name">{placeholderText}</div>
    </div>
  );
};

AppPlaceholder.propTypes = {
  onPlaceholderClick: T.func.isRequired,
  isActiveItem: T.bool.isRequired,
  itemNumber: T.number.isRequired,
  customTexts: T.shape({
    app_selection_text: T.string,
  }),
};

// Mobile
export const AppItemMobile = ({
  onAppRemove,
  app: { ref_no, big_icon_url, icon_url, store, name },
}) => (
  <div className="app-selection-app-box" onClick={() => onAppRemove(ref_no)}>
    <span className="app-selection-app-remove" />
    <AppIcon
      url={big_icon_url || icon_url}
      store={store}
      size={48}
      alt={name}
      containerClasses="app-selection-app-item"
      hideHtmlTitle
    />
  </div>
);

AppItemMobile.propTypes = {
  onAppRemove: T.func.isRequired,
  app: T.shape({
    ref_no: T.oneOfType([T.string, T.number]),
    big_icon_url: T.string,
    icon_url: T.string,
    store: T.string,
    name: T.string,
  }).isRequired,
};

export const AppPlaceholderMobile = ({ onPlaceholderClick, showPulseAnimation, showSelected }) => (
  <div
    onClick={onPlaceholderClick}
    className={cx('app-selection-app-box app-selection-app-placeholder', {
      'pulse-box-shadow': showPulseAnimation,
      'app-selection-app-placeholder-taped': showSelected,
    })}
  >
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" stroke={color} strokeDasharray="2 2" />
      <text x="50%" y="54%" dominantBaseline="middle" fill={color} textAnchor="middle">
        +
      </text>
    </svg>
  </div>
);

AppPlaceholderMobile.propTypes = {
  onPlaceholderClick: T.func.isRequired,
  showPulseAnimation: T.bool,
  showSelected: T.bool,
};
